import React from "react";
import Heading from "../components/common/Heading";

export default function Booking() {
  return (
    <>
      <Heading heading="Booking" title="Home" subtitle="Booking" />
    </>
  );
}
